import React, {useEffect, useState} from 'react';
import { Box, List, ListItem, Tooltip, IconButton, Button, TextField, Grid, MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import { Routes, Route, Outlet, Link, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SendEmailPage from './SendEmailPage';
import ManagementPage from './ManagementPage';
import SettingsPage from './SettingsPage'
import SettingsIcon from '@mui/icons-material/Settings';
import { useStateContext } from '../contexts/ContextProvider'
import { createEmail, editEmail, editManage, createManage } from '../utils/connect'

const TextStyle = styled.div`
    background-image: linear-gradient(90deg,#2e4f8b 0%,#3e589d 35%,#8f619b 60%,#d0718f 70%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent
`

const MainContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    height: 97vh;

    @media screen and (max-width: 1080px) {
        flex-direction: column;
    }
`;

const NavigationContainer = styled(Box)`
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: #fff;
    width: 3%;

    @media screen and (max-width: 1080px) {
        width: 100%;
        height: auto;
    }
`;

const NavigationList = styled(List)`
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90%;

    > div.autoFill {
        flex-grow: 1;
    }

    @media screen and (max-width: 1080px) {
        flex-direction: row;
        justify-content: space-around;
        margin-top: 0px;
    }
`;

const NavigationItem = styled(ListItem)`
    display: flex; 
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const ContentContainer = styled(Box)`
    flex-grow: 1;
`;
const Overlay = styled.div`
    background-color: rgba(128, 128, 128, 0.3);
    height: 98%;
    width: 99%;
    position: absolute;
    z-index: 1200;
    overflow: hidden;
`;

const Pane = styled.div`
    background-color: white;
    padding: 16px;
    border-radius: 8px;
    margin-top: 10%;
    margin-left: 50%;
    transform: translateX(-50%);
    width: 50vw;
    display: flex;
    flex-direction: column;
`;

const PaneButton = styled(Button)`
    border: 1px solid;
    padding: 8px 16px;
    border-radius: 8px;
    margin-top:50px;
    margin-bottom:50px;
    margin-left:80px;
    margin-right:80px;
`;

const CenterButtonGroup = styled.div`
    display: flex;
    justify-content: center;
`;

function DashboardPage() {
    const location = useLocation();
    const {
        emailPaneVisible, 
        setEmailPaneVisible, 
        managePaneVisible, 
        setManagePaneVisible, 
        toEditId, 
        sendData, 
        setSendData, 
        manageData,
        setManageData,
        lastMethod} = useStateContext();
    const [emailInfoToChange, setEmailInfoToChange] = useState({
        name:'',
        company:'',
        email:'',
        business_matching_meeting:'',
    })
    const [manageInfoToChange, setManageInfoToChange] = useState({
        name:'',
        uen_number:'',
        company:'',
        email:'',
        business_matching_meeting:'',
        mobile:'',
        remarks:'',
    })

    const handleEmailInputChange = event => {
        const { name, value } = event.target;
        setEmailInfoToChange(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleManageInputChange = event => {
        const { name, value } = event.target;
        setManageInfoToChange(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleEmailCancel = () => {
        setEmailPaneVisible(false);
        if(lastMethod === "Add") {
            const newData = sendData.slice(1, sendData.length);
            setSendData(newData);
        }
    }

    const handleEmailConfirm = async () => {
        setEmailPaneVisible(false);
        const updateSendData = sendData.map(item => (item.id === toEditId ? {...emailInfoToChange, last_modified: new Date().toISOString()} : item))
        setSendData(updateSendData)
        if(lastMethod === "Add") {
            await createEmail(emailInfoToChange.id, emailInfoToChange.name, emailInfoToChange.company, emailInfoToChange.email, emailInfoToChange.business_matching_meeting, emailInfoToChange.last_modified);
        }
        else {
            await editEmail(emailInfoToChange.id, emailInfoToChange.name, emailInfoToChange.company, emailInfoToChange.email, emailInfoToChange.business_matching_meeting, emailInfoToChange.last_modified);
        }
    }

    const handleManageCancel = () => {
        setManagePaneVisible(false);
        if(lastMethod === "Add") {
            const newData = manageData.slice(1, manageData.length);
            setManageData(newData);
        }
    }

    const handleManageConfirm = async () => {
        setManagePaneVisible(false);
        const updateManageData = manageData.map(item => (item.id === toEditId ? {...manageInfoToChange, last_modified: new Date().toISOString()} : item))
        setManageData(updateManageData)
        //if(lastMethod === "Add") {
        //    await createManage(emailInfoToChange.id, emailInfoToChange.name, emailInfoToChange.uen_number, emailInfoToChange.company, emailInfoToChange.email, emailInfoToChange.business_matching_meeting, emailInfoToChange.mobile, emailInfoToChange.remarks);
        //}
        //else {
        //    await editManage(emailInfoToChange.id, emailInfoToChange.name, emailInfoToChange.uen_number, emailInfoToChange.company, emailInfoToChange.email, emailInfoToChange.business_matching_meeting, emailInfoToChange.mobile, emailInfoToChange.remarks);
        //}
    }

    useEffect(() => {
        setEmailInfoToChange(sendData.filter(item => item.id === toEditId)[0])
    }, [toEditId, sendData])

    useEffect(() => {
        setManageInfoToChange(manageData.filter(item => item.id === toEditId)[0])
    }, [toEditId, manageData])
    return (
        <>
        {
            managePaneVisible && 
            <Overlay onClick={event => event.stopPropagation()}>
                <Pane>
                    <h1 style={{"marginLeft":"20px"}}><TextStyle>{lastMethod} Manage Data</TextStyle></h1>
                    <Grid container spacing={3}>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={manageInfoToChange?.name || ''}
                        onChange={handleManageInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="UEN Number"
                        name="uen_number"
                        value={manageInfoToChange?.uen_number || ''}
                        onChange={handleManageInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Company"
                        name="company"
                        value={manageInfoToChange?.company || ''}
                        onChange={handleManageInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        value={manageInfoToChange?.email || ''}
                        onChange={handleManageInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Business matching meeting"
                        name="business_matching_meeting"
                        value={manageInfoToChange?.business_matching_meeting || ''}
                        onChange={handleManageInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Mobile"
                        name="mobile"
                        value={manageInfoToChange?.mobile || ''}
                        onChange={handleManageInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Remarks"
                        name="remarks"
                        value={manageInfoToChange?.remarks || ''}
                        onChange={handleManageInputChange}
                        size="small"
                    />
                    </Grid>
                    </Grid>
                    <CenterButtonGroup>
                        <PaneButton style={{"backgroundColor":"#F31559", "color":"white"}}  onClick={handleManageConfirm}>CONFIRM</PaneButton>
                        <PaneButton onClick={handleManageCancel}>CANCEL</PaneButton>
                    </CenterButtonGroup>
                </Pane>
            </Overlay>
        }
        {
            emailPaneVisible &&
            <Overlay onClick={event => event.stopPropagation()}>
                <Pane>
                    <h1 style={{"marginLeft":"20px"}}><TextStyle>{lastMethod} Email Data</TextStyle></h1>
                    <Grid container spacing={3}>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={emailInfoToChange?.name || ''}
                        onChange={handleEmailInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Company"
                        name="company"
                        value={emailInfoToChange?.company || ''}
                        onChange={handleEmailInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        value={emailInfoToChange?.email || ''}
                        onChange={handleEmailInputChange}
                        size="small"
                    />
                    </Grid>
                    <Grid item sm={12} md={6}> 
                    <TextField
                        fullWidth
                        label="Business matching meeting"
                        name="business_matching_meeting"
                        value={emailInfoToChange?.business_matching_meeting || ''}
                        onChange={handleEmailInputChange}
                        size="small"
                    />
                    </Grid>
                    </Grid>
                    <CenterButtonGroup>
                        <PaneButton style={{"backgroundColor":"#F31559", "color":"white"}}  onClick={handleEmailConfirm}>CONFIRM</PaneButton>
                        <PaneButton onClick={handleEmailCancel}>CANCEL</PaneButton>
                    </CenterButtonGroup>
                </Pane>
            </Overlay>
        }
        <MainContainer>
            <NavigationContainer>
                <NavigationList>
                    <NavigationItem component={Link} to="/main/">
                        <Tooltip title="Send">
                            <IconButton style={{ color : location.pathname === '/main/' ? "#45CFDD" : "gray" }}>
                                <MailOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    </NavigationItem>
                    <NavigationItem component={Link} to="/main/management">
                        <Tooltip title="Management">
                            <IconButton style={{ color : location.pathname === '/main/management' ? "#45CFDD" : "gray" }}>
                                <ManageAccountsIcon />
                            </IconButton>
                        </Tooltip>
                    </NavigationItem>
                    <div className="autoFill" />
                    <NavigationItem component={Link} to="/main/settings">
                        <Tooltip title="Settings">
                            <IconButton style={{ color : location.pathname === '/main/settings' ? "#45CFDD" : "gray" }}>
                                <SettingsIcon />
                            </IconButton>
                        </Tooltip>
                    </NavigationItem>
                </NavigationList>
            </NavigationContainer>
            <ContentContainer>
                <Outlet />
                <Routes>
                    <Route path="/" element={<SendEmailPage />} />
                    <Route path="/management" element={<ManagementPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                </Routes>
            </ContentContainer>
        </MainContainer>
        </>
    )
}

export default DashboardPage
